/**
 * A short two-tone "ping" for new-message notifications, synthesised with the Web Audio API so no
 * audio asset needs bundling. Fully guarded: browsers block audio until the user has interacted
 * with the page, and some environments have no AudioContext — either way this is a silent no-op.
 */
export function playPing(): void {
  try {
    const Ctor: typeof AudioContext | undefined =
      typeof window === 'undefined'
        ? undefined
        : (window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext);
    if (!Ctor) return;
    const ctx = new Ctor();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    const t0 = ctx.currentTime;
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, t0);
    osc.frequency.setValueAtTime(1175, t0 + 0.08);
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.exponentialRampToValueAtTime(0.12, t0 + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.25);
    osc.start(t0);
    osc.stop(t0 + 0.26);
    osc.onended = () => {
      void ctx.close();
    };
  } catch {
    // audio blocked or unavailable: stay silent
  }
}
